import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const options = {
  lng: 'en',
  ns: 'common',
  defaultNS: 'common',
  // configure as key fallback (fulltext keys)
  nsSeparator: false,
  keySeparator: false,
  fallbackLng: false,
  returnEmptyString: false
};

export default (resources = {}, lng = 'en') => {
  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({ ...options, resources, lng });
  }

  return i18n;
};
